module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_Cacahuate_japonés.96cac4ba.pdf";